/** @format */
import { AxiosRequestConfig } from 'axios';

import { MarketCode } from '@toucan/config/markets';

import { SelectedWarranty } from '@toucan/types/warranty';

import { client } from '@toucan/services/request-client';
import { rejectIfInvalidCSRFResponse } from '@toucan/services/requests/csrf';

import { CalcServiceResponse } from '@toucan/client/global/calculation-service';

type PurchaseWarrantyProps = {
    selectedWarranties: SelectedWarranty[];
    market: MarketCode;
    checkoutId: string;
    csrfToken: string;
};
export const purchaseWarranty = async ({
    selectedWarranties,
    market,
    checkoutId,
    csrfToken,
}: PurchaseWarrantyProps): Promise<{ totals?: CalcServiceResponse }> => {
    const config: AxiosRequestConfig = {
        headers: {
            'Content-Type': 'application/json',
            'X-Market': market.toLowerCase(),
            'CSRF-Token': csrfToken,
        },
    };

    const response = await client.post(
        `/checkout/${checkoutId}/add-warranties/`,
        { selectedWarranties },
        config
    );

    const { data } = await rejectIfInvalidCSRFResponse(response);

    return {
        totals: data?.totals,
    };
};
